<template>
   
    <div> 
        <div class="crumbs" hidden="true"  style="margin-left:10px;">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 产品管理
                </el-breadcrumb-item>
                <el-breadcrumb-item>共享文档</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
          <el-card shadow="hover"  class="searchCard" >
                <span class="label-span">
                    <label class="label">创建人</label> 
                    <el-input v-model.trim="query.loginName" placeholder="操作人" class="handle-input mr15"></el-input> 
                </span> 
                <span class="label-span">
                    <label class="label">文档分类</label> 
                    <el-select v-model="query.docType"  placeholder="文档分类" clearable class="handle-select mr10">
                        <el-option value="" label="全部"  />  
                        <el-option v-for="item in select.option" :key="item.id" :label="item.optVal" :value="item.optKey" /> 
                    </el-select>
                </span>   
                <span class="label-span">
                    <label class="label">文档名称</label> 
                    <el-input v-model.trim="query.docName" placeholder="文档名称" class="handle-input mr15"></el-input> 
                </span>  
                <el-button type="success" icon="el-icon-search"  class="mr10"  @click="handleSearch">搜索</el-button>
                <el-button type="error" icon="el-icon-refresh" class="mr10" style="margin-right:25px;"  @click="refreshSearch">重置</el-button>
                <el-button  type="primary"  icon="el-icon-lx-roundadd" class="mr10"  @click="addBind" >添加文档</el-button> 
                <el-button  type="danger"  icon="el-icon-lx-delete" class="mr10"  @click="delMore" >删除文档</el-button> 
              
               
          </el-card>
          <el-card shadow="hover"  class="containCard" >
            <el-table :data="tableData" class="table"  ref="multipleTable" header-cell-class-name="table-header"  @selection-change="handleSelectionChange" v-loading="loading"  element-loading-text="请稍等" element-loading-spinner="el-icon-loading" >
                <el-table-column type="selection" width="45" align="center"></el-table-column> 
                <el-table-column prop="loginName" width="120" align="left" label="创建人"> </el-table-column>       
                <el-table-column prop="typeName" width="90" align="center" label="文档分类">
                    <template slot-scope="scope" >   
                        <el-tag>{{scope.row.typeName}}</el-tag>
                    </template> 
                </el-table-column>     
                <el-table-column prop="docName" min-width="160" align="left" label="文档名称"></el-table-column>      
                <el-table-column prop="descript" min-width="180" align="left" label="文档描述"></el-table-column>      
                <el-table-column prop="num" width="80" align="center" label="文件数量"></el-table-column>        
                <el-table-column prop="status" width="80" align="center" label="分享状态">
                    <template slot-scope="scope" >   
                        <el-tooltip :content="scope.row.status=='1'?'已开启分享':'分享已关闭'" placement="top">
                            <el-switch @change="handleStatus(scope.$index, scope.row)"
                                v-model="scope.row.status"
                                active-color=""
                                inactive-color="red"
                                active-value="1"
                                inactive-value="0">
                            </el-switch>
                        </el-tooltip>
                    </template> 
                </el-table-column>  
                <el-table-column prop="createTime" width="165" align="center"  label="创建时间"> </el-table-column> 
                <el-table-column prop="updateTime" width="165" align="center"  label="更新时间"> </el-table-column> 
                <el-table-column label="操作" width="260" align="center"  fixed="right">
                    <template slot-scope="scope"> 
                        <span class='tableOperBtn' @click="handleEdit(scope.row)" ><i class='el-icon-edit'></i> 编辑</span>
                        <span class='tableOperBtn' @click="handelForm(scope.row)" ><i class='el-icon-lx-attention'></i> 查看</span>
                        <span class='tableOperBtn' @click="handelShare(scope.$index, scope.row)" ><i class='el-icon-share'></i> 分享</span>  
                         
                    </template>
                </el-table-column>     
            </el-table>
            <div class="pagination">
                <el-pagination 
                   background
                    layout="total,  sizes,prev, pager, next,jumper"
                    :page-sizes="[10, 20, 50]"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange" 
                ></el-pagination>
            </div>
          </el-card> 
        <!-- 新建自主渠道弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="新增文档" :visible.sync="addVisible" :modal-append-to-body='false' top="80px" width="480px">
            <el-form ref="form1" :model="form1" label-width="80px" @submit.native.prevent="saveForm">
                <el-form-item label="文档名称">
                    <el-input v-model.trim="form1.docName"  placeholder="不超过20个字" style="width:360px;"></el-input>
                </el-form-item> 
                <el-form-item label="文档分类">   
                    <el-select v-model="form1.docType"  placeholder="文档分类" clearable style="width:100%"> 
                        <el-option v-for="item in select.option"  :key="item.id" :label="item.optVal" :value="item.optKey" /> 
                    </el-select>
                </el-form-item> 
                <el-form-item label="文档描述">
                    <el-input v-model.trim="form1.descript"  placeholder="不超过50个字" style="width:360px;"></el-input>
                </el-form-item>
                <el-form-item label="文件上传">
                    <el-upload :fileList="fileList" action="#" drag :file-list="fileList" :on-remove="handleRemove" :auto-upload="false" :limit="10" :on-change="handleChange" :on-exceed="handleExceed"
                    multiple>
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或点击上传</div>
                    <div class="el-upload__tip" slot="tip">单文件大小不超过50M</div>
                </el-upload> 
                </el-form-item>     
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveForm">{{ isSubmitting ? '提交中...' : '提 交' }}</el-button>
            </span>
        </el-dialog>
         
  

        <!-- 编辑自主渠道弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="编辑文档" :visible.sync="editVisible" :modal-append-to-body='false' top="50px" width="480px">
            <el-form ref="form" :model="form3" label-width="80px">
                <el-form-item label="文档名称">
                    <el-input v-model.trim="form3.docName"  placeholder="不超过20个字" style="width:360px;"></el-input>
                </el-form-item> 
                <el-form-item label="文档分类">   
                    <el-select v-model="form3.docType"  placeholder="文档分类" clearable style="width:100%"> 
                        <el-option v-for="item in select.option"  :key="item.id" :label="item.optVal" :value="item.optKey" /> 
                    </el-select>
                </el-form-item> 
                <el-form-item label="文档描述">
                    <el-input v-model.trim="form3.descript"  placeholder="不超过50个字" style="width:360px;"></el-input>
                </el-form-item>
                <el-form-item label="文件上传">
                    <el-upload :fileList="fileList" action="#" drag :file-list="fileList" :on-remove="handleRemove" :auto-upload="false" :limit="10" :on-change="handleChange" :on-exceed="handleExceed"
                    multiple>
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或点击上传</div>
                    <div class="el-upload__tip" slot="tip">单文件大小不超过50M</div>
                </el-upload> 
                </el-form-item>     
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="文件记录" :visible.sync="fileVisible" :modal-append-to-body='false' top="80px" width="780px" v-loading="loading2"  element-loading-text="后台下载中" element-loading-spinner="el-icon-loading">
             <el-table :data="listData" height="460px"  :show-header="false" class="table" style="margin-top:-20px"  ref="multipleTable" header-cell-class-name="table-header" > 
                <el-table-column prop="logo" width="76" align="left" label="文件图标">
                    <template slot-scope="scope" >   
                        <img style="width:35px;" v-if="scope.row.fileType=='.xlsx' || scope.row.fileType=='.xls'" :src="require('/src/assets/icon/excel.png')" />
                        <img style="width:35px;" v-else-if="scope.row.fileType=='.pdf'" :src="require('/src/assets/icon/pdf.png')" />
                        <img style="width:35px;"  v-else-if="scope.row.fileType=='.word' || scope.row.fileType=='.doc' || scope.row.fileType=='.docx'" :src="require('/src/assets/icon/word.png')" />
                        <img style="width:35px;" v-else-if="scope.row.fileType=='.jfif' || scope.row.fileType=='.png' || scope.row.fileType=='.jpg' || scope.row.fileType=='.jfif'  || scope.row.fileType=='.jpeg'  || scope.row.fileType=='.gif'" :src="require('/src/assets/icon/img.png')" />
                        <img style="width:35px;" v-else-if="scope.row.fileType=='.txt'" :src="require('/src/assets/icon/txt.png')" />
                        <img style="width:35px;" v-else-if="scope.row.fileType=='.ppt' || scope.row.fileType=='.pptx'" :src="require('/src/assets/icon/ppt.png')" />
                        <img style="width:35px;" v-else-if="scope.row.fileType=='.zip' || scope.row.fileType=='.tar' || scope.row.fileType=='.rar' || scope.row.fileType=='.7z' || scope.row.fileType=='.iso'" :src="require('/src/assets/icon/zip.png')" />
                    </template> 
                </el-table-column>     
                <el-table-column prop="descript" min-width="200" align="left" label="文件名称">
                    <template slot-scope="scope" >   
                        <p style="font-size:14px;line-height:18px;color:#666;">{{scope.row.fileName}}</p>
                        <p>{{scope.row.fileSize}}</p>
                    </template> 
                </el-table-column>   
                <el-table-column prop="createTime" width="160" align="left"  label="上传时间"> </el-table-column>  
                <el-table-column label="操作" width="120" align="right"  >
                    <template slot-scope="scope">    
                         <el-button  type="error" @click="downFile( scope.row)" >↓</el-button>  
                    </template>
                </el-table-column>   
            </el-table>  
        </el-dialog>  
        <el-dialog :close-on-click-modal="false" title="文档分享" :modal-append-to-body='false' :visible.sync="shareVisible" top="30px" width="860px">
            <div > 
                <span class="label-span">
                    <label class="label">渠道名称</label> 
                    <el-input v-model.trim="query2.loginName" placeholder="渠道名称" style="width:100px;" class="handle-input mr10"></el-input> 
                </span>  
                <span class="label-span">
                    <label class="label">手机号码</label> 
                    <el-input v-model.trim="query2.phone" placeholder="手机号码" style="width:100px;" class="handle-input mr10"></el-input> 
                </span>
                <span class="label-span">
                    <label class="label">分享状态</label> 
                    <el-select v-model="query2.status"  placeholder="是否分享" filterable  clearable class="handle-select mr15">
                        <el-option value="" label="全部"  /> 
                        <el-option value="0" label="未分享"  /> 
                        <el-option value="1" label="已分享"  />  
                    </el-select>      
                </span>  
                
                <el-button type="success" icon="el-icon-search" class="mr10"   @click="handleSearch2">搜索</el-button>
                <el-button type="error" icon="el-icon-refresh" class="mr15"   @click="refreshSearch2">重置</el-button>  
            </div>
            <el-table   :data="tableData2"  class="table"  ref="multipleTable" header-cell-class-name="table-header"  @selection-change="handleSelectionChange2" 
             v-loading="loading3"  element-loading-text="请稍等..." element-loading-spinner="el-icon-loading" >
                <el-table-column type="selection" width="45" align="center"></el-table-column> 
                <el-table-column prop="loginName" min-width="100" align="left" label="渠道名称"></el-table-column>
                <el-table-column prop="phone" min-width="100" align="left" label="手机号码"></el-table-column>  
                <el-table-column prop="status" fixed="right" width="80" align="center" label="分享状态">
                    <template slot-scope="scope" > 
                         <el-tooltip :content="scope.row.status=='0'?'未分享':'已分享'" placement="top">
                            <el-switch @change="handleStatus2(scope.row)"
                                v-model="scope.row.status"
                                active-color=""
                                inactive-color=""
                                active-value="1"
                                inactive-value="0">
                            </el-switch>
                        </el-tooltip>
                    </template>  
                </el-table-column>    
            </el-table> 
            <div class="pagination">
                <el-pagination 
                    background
                    layout="total,  sizes,prev, pager, next,jumper"
                    :page-sizes="[10,20]"
                    :current-page="query2.pageIndex"
                    :page-size="query2.pageSize"
                    :total="pageTotal2"
                    @size-change="handleSizeChange2"
                    @current-change="handlePageChange2" 
                ></el-pagination>
            </div> 
        </el-dialog> 
          
    </div>
</template>
<script>
import {fetchData,fetchData2,saveForm,handDelete,deleteMore,changeForm,changeStatus,getFilesDetail,getListData,downDocFile,changeStatus2} from '../../api/docShare'; 
import {fetchSelect} from '../../api/docShareType'; 
export default {

    data() {
        return {  
            isSubmitting: false, // 是否正在提交
            Timeout:'', 
            activeNames:1,
            docCode:'',
            select:{ option:'',  },
            sendSms:{
                code:'', 
                content:'发送验证码',
                type:'danger',
                disabled:false,
                color:'color:#fff',
             },
            fileList:[],
            query: { 
                pageIndex: 1,
                pageSize: 10,  
            },
            query2: { 
                pageIndex: 1,
                pageSize: 10,  
            },
            tableData: [],
            tableData2: [],
            listData:[],
            multipleSelection: [],
            delList: [],
            fileVisible:false,
            editVisible: false,
            editPlusVisible: false,
            addVisible: false,
            addPlusVisible:false,
            detailVisible:false,  
            shareVisible:false,  
            loading:false,
            loading2:false,
            loading3:false,
            row:{},
            pageTotal: 0,
            pageTotal2: 0,
            form: {  
                ids:'',
                names:'',
            },
            form1: {
                ctype:'2',  
            },
            form2: {   },
            form3: {   },
            form4: {   },
            idx: -1,
            id: -1
        };
    },
    created() {
         
    },
    //页面加载方法
    mounted: function () { 
        //查询列表
        this.getSelect();
        this.getData();  
    },

    methods: {  
        // 触发搜索按钮 
        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
          copyLink(text,name){  
            var copy = document.createElement("input");
            copy.setAttribute("value", text);
            document.body.appendChild(copy);
            copy.select();
            document.execCommand("copy");
            document.body.removeChild(copy);  
            //提示已复制
            this.$message.success(name+"复制成功");  
        },
       
        delMore(){
            const length = this.multipleSelection.length; 
            if(length==0){
                this.$message.error("请勾选需要删除的行");
                return;
            } 
            let data = {};
            let ids = ''; 
            for (let i = 0; i < length; i++) {
                ids += this.multipleSelection[i].id + ','; 
            }
            ids = ids.substr(0,ids.length-1);   
            data.ids = ids;
            this.$confirm('确认删除吗？', '提示', {
                type: 'warning'
            }).then(() => {
                this.loading = true; 
                deleteMore(data).then(res => {
                this.loading = false;
                if(res.code=='200'){ 
                    this.$notify({ title: '成功', message: '删除成功',duration: 1000, type: 'success' }); 
                    this.getData(); 
                }else{ 
                    this.$message.error(res.message);
                }  
            })
            }) 
            
        },
        getSelect(){
            fetchSelect(this.select).then(res => {   
                if(res.code=='200'){ 
                    this.select.option = res.data; 
                }
            });
        },
         handleSelectionChange(val) {
            this.multipleSelection = val; 
        },
        handleRemove(file, fileList) {
            let i = this.fileList.indexOf(file);   
            this.fileList.splice(i,1); 
        }, 
        handleExceed(files, fileList) {
            this.$message.warning(`每次只能上传10个文件`);
        },
        //详情图上传成功追加数据 
        handleChange(file,fileList) { 
            file.name.split(".")[1] === "xls" 
            const isMax = file.size / 1024 / 1024  < 50; 
            if (!isMax) {
                this.$message.error("导入文件大小不能超过 50MB!");
                fileList.splice(-1, 1);
                return false;
            }  
            this.fileList = fileList;	  
            
        }, 
       
        //文件下载
        downFile(row) {
            this.loading = true
            downDocFile(row).then(res => {   
                this.loading = false
                if(res.code=='200'){ 
                    this.$notify({ title: '成功', message: '后台下载成功',duration: 1000, type: 'success' });
                }else{
                    this.$notify({ title: '失败', message: '后台下载异常',duration: 1000, type: 'error' });
                }
            });
        },
 
        

        //重置按钮
        refreshSearch(){  
            this.$set(this.query, 'loginName');    
            this.$set(this.query, 'docName');      
            this.$set(this.query, 'docType');      
            this.handleSearch();
        }, 
    

        //触发刷新按钮
        refresh(){
            history.go(0); 
        }, 

        //查询
        getData(){  
            this.query.stationId = this.stationId;  
            this.query.mid = this.mid;
            this.query.secret = this.secret; 
            this.loading = true;
            setTimeout( () => {
                this.loading = false;   
            }, 5000)
            fetchData(this.query).then(res => {  
                this.loading = false;
                if(res.code=='200'){ 
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.pageTotal ;  
                }else{
                    this.tableData = []; 
                    this.pageTotal = 0;
                } 
                
            });
        },
        
        // 新增渠道
        addBind() {
            this.fileList = [];
            this.addVisible = true; 
        },
        //保存新增
        saveForm() {   
            if (this.isSubmitting) return;
            this.isSubmitting = true; // 禁用按钮
            if( !this.form1.docName ){
                this.isSubmitting = false;
                this.$message.error("请填写文档名称");
                return;
            }  
            if( !this.form1.docType ){
                this.isSubmitting = false;
                this.$message.error("请选择文档分类");
                return;
            }   
            if(this.fileList.length==0){
                this.isSubmitting = false;
                this.$message.error("请上传文件!"); 
                return;
            } 
            let formData = new FormData();
            formData.append("docName",this.form1.docName);
            formData.append("docType",this.form1.docType);  
            formData.append("descript",this.form1.descript);  
            formData.append("docRange","1");   
            for(let j = 0; j < this.fileList.length; j++) {
                formData.append("files", this.fileList[j].raw,this.fileList[j].name); 
            } 
            this.loading = true;
            this.addVisible = false;
            setTimeout( () => {
                this.loading = false;  
                this.getData();
            }, 5000)
            saveForm(formData).then(res => { 
                this.loading = false;
                this.isSubmitting = false; 
                if(res.code=='200'){
                    this.fileList = [];  
                    this.$message.success(res.message); 
                    this.refreshSearch();
                }else{
                    this.addVisible = true;
                    this.$message.error(res.message); 
                }
            });
        },

        

        // 编辑操作
        handleEdit(row) {  
            //文件回显    
            this.fileList = [];
            let data = {};
            data.docCode = row.docCode;
            getFilesDetail(data).then(res => {
                if(res.code=='200'){  
                    this.fileList = res.data;     
                }else{ 
                    this.$message.error(res.message); 
                } 
            });     
            this.editVisible = true; 
            this.form3 = row;  
        },

        handelForm(row){
            this.fileVisible = true;
            let data = {};
            data.docCode = row.docCode;
            getListData(data).then(res => {
                if(res.code=='200'){  
                    this.listData = res.data;     
                }else{ 
                    this.$message.error(res.message); 
                } 
            });      
        },
 
        handelShare(row){
            this.shareVisible = true;
            this.docCode = row.docCode;
            this.getData2();
        },
        getData2(){
            let data = {};
            this.query2.docCode = this.docCode;
            this.loading3 = true;
            setTimeout( () => {
                this.loading3 = false;   
            }, 5000)
            fetchData2(this.query2).then(res => {
                this.loading3 = false;
                if(res.code=='200'){ 
                    this.tableData2 = res.data.list;
                    this.pageTotal2 = res.data.pageTotal ;  
                }else{
                    this.tableData2 = []; 
                    this.pageTotal2 = 0;
                } 
            });   
        },
        // 保存更改
        saveEdit() {   
            if( !this.form3.docName ){
                this.$message.error("请填写文档名称");
                return;
            }  
            if( !this.form3.docType ){
                this.$message.error("请选择文档分类");
                return;
            }   
            if(this.fileList.length==0){
                this.$message.error("请上传文件!"); 
                return;
            } 
            let formData = new FormData();
            formData.append("docCode",this.form3.docCode);
            formData.append("docName",this.form3.docName);
            formData.append("docType",this.form3.docType);  
            formData.append("descript",this.form3.descript);  
            formData.append("docRange","1");   
            var fileIds="";
            for(let j = 0; j < this.fileList.length; j++) {
                if(this.fileList[j].raw){ 
                    formData.append("files", this.fileList[j].raw,this.fileList[j].name); 
                }else{
                    fileIds+= +this.fileList[j].fileId+","; 
                } 
            } 
            if(fileIds.length>1){fileIds=fileIds.substr(0,fileIds.length-1)}
            formData.append("fileIds",fileIds);  
            this.loading = true;
            this.editVisible = false;
            setTimeout( () => {
                this.loading = false;  
                this.getData();
            }, 5000)
            changeForm(formData).then(res => {
                this.loading = false;
                if(res.code=='200'){
                    this.editVisible = false; 
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                    this.editVisible = true;
                    this.$message.error(res.message); 
                }
            });
        },
        // q启用、禁用--改变状态
        handleStatus(index, row) {  
            var tips ;
            var content; 
            if(row.status=='0'){ 
                row.status='1';
                tips = "关闭分享";
                content = "确定关闭分享吗？";
            }else{ 
                row.status = '0';
                tips = "开启分享";
                content = "确定开启分享吗？"; 
            }
            // 二次确认删除
            this.$confirm(content, '提示', {
                type: 'warning'
            }).then(() => { 
                if(row.status=='0'){ 
                    row.status='1' 
                }else{ 
                    row.status='0' 
                }
                changeStatus(row).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success(tips+'成功'); 
                        this.getData();
                    }else{ 
                        if(row.status=='0'){ 
                            row.status='1' 
                        }else{ 
                            row.status='0' 
                        }
                        this.$message.error(tips+'失败');
                    } 
                });
            })
            .catch(() => {}); 
           
        },
        handleStatus2(row){
            var tip ="";
            if(row.status==0){
                tip = "取消";
            } 
            row.docCode = this.docCode;
            changeStatus2(row).then(res => {   
                if(res.code=='200'){ 
                    this.$notify({ title: '成功', message: row.loginName+" "+tip+'分享成功',duration: 1000, type: 'success' });
                }else{
                    this.$message.error(row.loginName+" "+tip+'分享失败');
                }
            });
        },
        
        //详情
        handleDetail(index, row){
            this.form2 = row; 
            if(row.channelType=='1'){
                this.detailVisible = true; 
            }
            
        },
        // 删除
        handDelete(index, row) {  
            this.form.id=row.id; 
            this.form.mid = this.mid;
            this.form.stationId = this.stationId; 
            // 二次确认删除
            this.$confirm('该渠道所有商品将删除，是否要删除？', '提示', {
                type: 'warning'
            }).then(() => {
                this.loading = true;
                setTimeout( () => {
                    this.loading = false;  
                    this.getData();
                }, 5000)
                handDelete(this.form).then(res => {
                    this.loading = false;
                    if(res.code=='200'){ 
                        this.$message.success('删除成功'); 
                        this.$set(this.query, 'pageIndex', 1); 
                        this.getData();
                    }else if(res.code=='201'){
                        //处理该等级绑定的成员
                        this.$message.error("该渠道商品仍有订单未结算，请手动结算订单！"); 
                    }else{
                        this.$message.error("删除失败"); 
                    } 
                });
            }) 
        },
         handleSearch2() {
            this.$set(this.query2, 'pageIndex', 1);
            this.getData2();
        },
        // 分页导航
        handlePageChange(val) { 
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
        //分页数量更改导航
        handleSizeChange(val){
            this.$set(this.query, 'pageSize', val);
            this.getData();
        },
        //重置按钮
        refreshSearch2(){ 
            this.$set(this.query2, 'loginName'); 
            this.$set(this.query2, 'phone');    
            this.$set(this.query2, 'status');    
            this.handleSearch2();
        },
        // 分页导航
        handlePageChange2(val) { 
            this.$set(this.query2, 'pageIndex', val);
            this.getData2();
        },
        //分页数量更改导航
        handleSizeChange2(val){
            this.$set(this.query2, 'pageSize', val);
            this.getData2();
        }
    }
};
</script>

<style scoped>
.el-upload__tip {
    font-size: 12px; 
    margin-top: -40px;
    z-index: 100;
    position: absolute;
    color: #999;
    margin-left: 120px;
}
.label{
    background: #eee;
    font-size: 14px;
    height: 32px;
    display: inline-block;
    line-height: 33px;
    width:100px;
    text-align:center;
    color: #555;
  }
  .label-span{
      display: inline-block;
      height: 45px;
  }
.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    width: 100px;
    display: inline-block;
}

.handle-input {
    width: 150px;
    display: inline-block;
}
.handle-del {
    float:right; 
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
    margin-left:0;
}
.mr15 {
    margin-right: 15px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
